import Home from 'views/App/Home/Home.jsx'
import Calendario from 'views/App/Calendario/Calendario.jsx'
import CalendarioGiorno from 'views/App/CalendarioGiorno/CalendarioGiorno.jsx'
import Clienti from 'views/App/Clienti/Clienti.jsx'
import Promemoria from 'views/App/Promemoria/Promemoria.jsx'
import ClientiNonRisposto from 'views/App/Clienti/ClientiNonRisposto'

// material-ui-icons
import DashboardIcon from 'material-ui-icons/Dashboard'
import DateRange from 'material-ui-icons/DateRange'
import Event from 'material-ui-icons/Event'
import RecentActors from 'material-ui-icons/RecentActors'
import Alarm from 'material-ui-icons/Alarm'
import PhoneMissed from 'material-ui-icons/PhoneMissed'

var agentRoutes = [
  {
    path: '/home',
    name: 'Homepage',
    icon: DashboardIcon,
    component: Home,
  },
  {
    path: '/clienti',
    name: 'Clienti',
    icon: RecentActors,
    component: Clienti,
  },
  {
    path: '/non-risposto',
    name: 'Clienti senza risposta',
    icon: PhoneMissed,
    component: ClientiNonRisposto,
  },
  {
    path: '/calendario',
    name: 'Calendario',
    icon: DateRange,
    component: Calendario,
  },
  {
    path: '/impegni-giorno',
    name: 'Impegni del giorno',
    icon: Event,
    component: CalendarioGiorno,
  },
  {
    path: '/promemoria',
    name: 'Promemoria',
    icon: Alarm,
    component: Promemoria,
  },
  { redirect: true, path: '/', pathTo: '/home', name: 'Home' },
]

export default agentRoutes



// WEBPACK FOOTER //
// ./src/routes/agent.jsx